/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ weeks: NonNullable<unknown> }} Progress_EyebrowInputs */

const en_us2_progress_eyebrow = /** @type {(inputs: Progress_EyebrowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Last ${i?.weeks} weeks`)
};

const pt_br2_progress_eyebrow = /** @type {(inputs: Progress_EyebrowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Últimas ${i?.weeks} semanas`)
};

const es_419_progress_eyebrow = /** @type {(inputs: Progress_EyebrowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Últimas ${i?.weeks} semanas`)
};

const pt_pt2_progress_eyebrow = /** @type {(inputs: Progress_EyebrowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Últimas ${i?.weeks} semanas`)
};

const fr_fr2_progress_eyebrow = /** @type {(inputs: Progress_EyebrowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.weeks} dernières semaines`)
};

const de_de2_progress_eyebrow = /** @type {(inputs: Progress_EyebrowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Letzte ${i?.weeks} Wochen`)
};

const it_it2_progress_eyebrow = /** @type {(inputs: Progress_EyebrowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ultime ${i?.weeks} settimane`)
};

/**
* | output |
* | --- |
* | "Last {weeks} weeks" |
*
* @param {Progress_EyebrowInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_eyebrow = /** @type {((inputs: Progress_EyebrowInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_EyebrowInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_eyebrow(inputs)
	if (locale === "es-419") return es_419_progress_eyebrow(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_eyebrow(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_eyebrow(inputs)
	if (locale === "de-DE") return de_de2_progress_eyebrow(inputs)
	if (locale === "it-IT") return it_it2_progress_eyebrow(inputs)
	return en_us2_progress_eyebrow(inputs)
});
export { progress_eyebrow as "progress.eyebrow" }